import '../Dashboard.less';
import React from "react";
import { Card, Icon } from "antd";
import { useNavigate } from "react-router-dom";
import { useFetchBacklinksOverviewQuery } from '../../backlinks/service';
import { TimeUtil } from "../../utils/time";
import BacklinksOverview from '../../backlinks/overview/BacklinksOverview';
import CardTitle from '../CardTitle';
import SkeletonBox from '../SkeletonBox';
import { backlinksOverviewDashboardDisplayOrder } from '../../backlinks/settings';
import { getBacklinksOverviewForInterval } from '../../backlinks/utils';
import BacklinksChart from './BacklinksChart';


type Props = {
    websiteGuid: string;
    domain: string;
};

export default function BacklinksBox({ websiteGuid, domain }: Props) {
    const navigate = useNavigate();
    const currentDate = TimeUtil.utcNow();
    const sevenDaysAgo = TimeUtil.subtractDays(currentDate, 7);

    const { data: backlinksOverview, isLoading: isLoadingOverview } = useFetchBacklinksOverviewQuery({ domain });

    const overviewForDashboard = backlinksOverview ? getBacklinksOverviewForInterval(backlinksOverview, sevenDaysAgo.format('YYYY-MM-DD'), currentDate.format('YYYY-MM-DD')) : undefined;
    const overviewChartData = overviewForDashboard && overviewForDashboard['total_backlinks'] ? overviewForDashboard['total_backlinks'].map((item) => ({ ...item, type: 'Total Backlinks' })) : [];
    const isDataForDashboardOverview = !isLoadingOverview && overviewForDashboard;

    return (
        <div className="dashboard-backlinks-box">
            {isLoadingOverview && <SkeletonBox />}

            {!isLoadingOverview && (
                <Card
                    data-cy="backlinks-box"
                    title={
                        <CardTitle
                            title="Backlinks overview"
                            description="Over the last 7 days"
                        />
                    }
                    extra={
                        <div
                            className="view-report-btn"
                            onClick={() => navigate(`/backlinks?w_guid=${websiteGuid}`)}
                        >
                            <span>View report</span>
                            <Icon type="right" />
                        </div>
                    }
                >
                    {isDataForDashboardOverview && (
                        <BacklinksOverview
                            overview={overviewForDashboard}
                            displayOrder={backlinksOverviewDashboardDisplayOrder}
                            showChart={false}
                        />
                    )}

                    <BacklinksChart chartData={overviewChartData} />
                </Card>
            )}
        </div>
    );
}
